import { SmallLogo } from "./SmallLogo";

export const Icon = () => {
  return (
    <span className="mx-2 inline-block h-[24px] w-auto">
      <SmallLogo />
    </span>
  );
};


